var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.048 6.988a.75.75 0 1 0-1.096 1.024 152 152 0 0 0 3.722 3.808l-2.25 2.7a.75.75 0 1 0 1.152.96l2.168-2.602.005.005a356 356 0 0 0 2.52 2.455l.212.203.53.509 3.211-3.212 2.202 2.642a.75.75 0 0 0 1.152-.96l-2.289-2.747L20.03 8.03a.75.75 0 0 0-1.06-1.06l-6.98 6.979-.256-.248a350 350 0 0 1-1.933-1.887C8.27 10.306 6.404 8.44 5.048 6.988"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 4a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5h20a.5.5 0 0 1 .5.5v16a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5",
  clipRule: "evenodd"
})));
export default SvgMail;